import PhotoSwipeLightbox from "photoswipe/lightbox";
import {
  closeSVG,
  arrowPrevSVG,
  arrowNextSVG
} from "../utils/imageGalleryIcons";

class ImageGalleryZoom {
  constructor() {
    this.gallery = null;
    this.lightbox = null;
  }

  init() {
    this.gallery = document.querySelector(".product-page-carousel-container");

    this.lightbox = new PhotoSwipeLightbox({
      closeSVG,
      arrowPrevSVG,
      arrowNextSVG,
      gallery: this.gallery,
      loop: false,
      children: "img:not(.independent-best-badge)",
      pswpModule: () => import("photoswipe"),
      bgOpacity: 1,
      padding: { top: 32, bottom: 32, left: 32, right: 32 },
      zoom: false
    });
    this.lightbox.addFilter("domItemData", (itemData, element) => {
      itemData.src = element.getAttribute("data-high-res-image") || element.src;
      itemData.msrc = element.src;
      itemData.w = 1500;
      itemData.h = 1500;

      return itemData;
    });

    this.lightbox.on("uiRegister", () => {
      this.lightbox.pswp.ui.registerElement({
        className: "pswp__counter",
        order: 6,
        isButton: false,
        appendTo: "bar",
        onInit: (el, pswp) => {
          pswp.on("change", () => {
            const currentSlideElement = pswp.currSlide.data.element;
            // Not the alt: that describes the whole product for crawlers and
            // screen readers, where this caption only labels the face on show.
            const label = currentSlideElement.dataset.imageName || "";
            el.textContent = label;
          });
        }
      });
    });

    this.lightbox.on("afterInit", () => {
      const analyticsId = document.getElementById("product-page-analytics")
        ?.dataset?.analyticsId;

      analytics.track("Clicked Image/Zoom", {
        analytics_id: analyticsId,
        number: this.lightbox.pswp.currIndex + 1
      });
    });

    this.lightbox.init();

    const zoomButton = document.querySelector("#zoom-button");
    zoomButton.addEventListener("click", this.zoomImage);
  }

  // eslint-disable-next-line class-methods-use-this
  get numberOfVideoElementsBeforeSelectedIndex() {
    return Array.from(
      document.querySelectorAll(".product-page-carousel .pdp-carousel-cell")
    ).filter((element, index) => {
      return (
        index < window.mainFlkty.selectedIndex &&
        (!!element.querySelector("video") ||
          !!element.querySelector("img[src*='.gif']") ||
          !!element.querySelector("img[data-flickity-lazyload-src*='.gif']"))
      );
    }).length;
  }

  get currentImageIndex() {
    const carouselDots = Array.from(
      document.querySelectorAll(".pdp-carousel-dot")
    );
    const selectedDot = document.querySelector(".pdp-carousel-dot.bg-ink");
    return (
      carouselDots.indexOf(selectedDot) -
      this.numberOfVideoElementsBeforeSelectedIndex
    );
  }

  zoomImage = () => {
    this.lightbox.loadAndOpen(this.currentImageIndex, {
      gallery: this.gallery
    });
  };
}

export default ImageGalleryZoom;
